import React, { FC } from 'react'
import { extendedColord } from '../../../../../lib/extendedColord'

import styled from 'styled-components'
import { StageTimeline } from '../../../../../lib/useAnimationStageTimelines'
import { animated } from 'react-spring'
import { AnimatedArrowWithBorder } from './AnimatedArrowWithBorder'

export type Props = {
  canDrop: boolean
  timelines: {
    overlayFadeIn: StageTimeline
    borderShrink: StageTimeline
    labelAppear: StageTimeline
  }
}

export const Overlay: FC<Props> = ({ timelines, canDrop }) => {
  return (
    <Wrapper
      $active={canDrop}
      style={{
        opacity: timelines.overlayFadeIn.toValueRange([0, 1]),
        zIndex: timelines.overlayFadeIn.to(x => (x === 0 ? -1 : 300))
      }}
    >
      <InsetWrapper $active={canDrop}>
        <BorderElement
          $active={canDrop}
          style={{
            borderRadius: timelines.borderShrink.toValueRange([0, 10]),
            inset: timelines.borderShrink.toValueRange(['0px', '24px']),
            opacity: timelines.borderShrink.toValueRange([0, 1])
          }}
        />
      </InsetWrapper>
      <ContentWrapper
        style={{
          opacity: timelines.labelAppear.toValueRange([0, 1]),
          marginTop: timelines.labelAppear.toValueRange([-10, 0])
        }}
      >
        <AnimatedArrowWithBorder active={canDrop} />
        <Text $active={canDrop}>Drop files here</Text>
      </ContentWrapper>
    </Wrapper>
  )
}

const Wrapper = styled(animated.div)<{ $active: boolean }>`
  position: absolute;

  z-index: 300;
  inset: 0;

  background-color: ${props => props.theme.colors.silverLight};
  background-color: ${props =>
    props.$active && extendedColord(props.theme.colors.silverLight).darken(0.03).toHex()};
  transition: background-color 300ms;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const InsetWrapper = styled.div<{ $active: boolean }>`
  position: absolute;
  inset: 0;
  inset: ${props => props.$active && '5px'};

  transition: inset 300ms;
`

const BorderElement = styled(animated.div)<{ $active: boolean }>`
  position: absolute;
  border: 1px dashed ${props => props.theme.colors.greyDark};
  border-color: ${props => props.$active && props.theme.colors.black};
  transition: border-color 300ms;
`

const ContentWrapper = styled(animated.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Text = styled.div<{ $active: boolean }>`
  color: ${props => props.theme.colors.greyDark};
  color: ${props => props.$active && props.theme.colors.black};
  transition: color 300ms;

  font-size: 24px;
  line-height: 24px;
  margin-top: 12px;
`

export type DropOverlayProps = Props
